import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenu } from "src/models/Maintenance/MainMenu.models";

interface MainMenuState {
  menus: IMenu[];
  menuToEdit: IMenu | null;
}

const initialState: MainMenuState = {
  menus: [],
  menuToEdit: null,
};

const mainMenuSlice = createSlice({
  name: "MainMenu",
  initialState,
  reducers: {
    setMainMenuList: (state, action: PayloadAction<IMenu[]>) => {
      state.menus = action.payload;
    },
    concatListMenu: (state: MainMenuState, action: PayloadAction<IMenu[]>) => {
      state.menus = [...state.menus.concat(action.payload)];
    },
    setMainMenuToEdit: (state, action: PayloadAction<IMenu | null>) => {
      state.menuToEdit = action.payload;
    },
    addMainMenu: (state, action: PayloadAction<IMenu>) => {
      state.menus.push(action.payload);
    },
    updateMainMenu: (state, action: PayloadAction<IMenu>) => {
      let itemIndex = state.menus.findIndex(
        item => item.menuId === action.payload.menuId
      );
      if (itemIndex !== -1) state.menus[itemIndex] = action.payload;
    },
    deleteMainMenu: (state, action: PayloadAction<number>) => {
      const newArray = state.menus.filter(
        item => item.menuId !== action.payload
      );
      state.menus = newArray;
    },
  },
});

export const {
  setMainMenuList,
  concatListMenu,
  setMainMenuToEdit,
  addMainMenu,
  updateMainMenu,
  deleteMainMenu,
} = mainMenuSlice.actions;

export default mainMenuSlice.reducer;
